import get from 'lodash.get';

import { FavoriteType } from '../../types';

import { createDeepEqualSelector } from '../utils/selectors';

import { FavoritesStoreType } from './types';

const selectFavorites = (state: any): FavoritesStoreType => state.favorites;

export const selectFavoritesData = createDeepEqualSelector(
  selectFavorites,
  (favorites: FavoritesStoreType): FavoriteType[] => get(favorites, 'data', []),
);

export const selectIsLoading = createDeepEqualSelector(
  selectFavorites,
  (favorites: FavoritesStoreType): boolean => favorites.loading,
);

export const selectErr = createDeepEqualSelector(
  selectFavorites,
  (favorites: FavoritesStoreType): boolean => favorites.err,
);

export const selectErrMsg = createDeepEqualSelector(
  selectFavorites,
  (favorites: FavoritesStoreType): string => favorites.errMsg,
);
